/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Landing_Footer_CopyrightInputs */

const zh_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} StudyOS. 保留所有权利。`)
};

const en_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} StudyOS. All rights reserved.`)
};

const es_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} StudyOS. Todos los derechos reservados.`)
};

/**
* | output |
* | --- |
* | "© {year} StudyOS. All rights reserved." |
*
* @param {Landing_Footer_CopyrightInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_footer_copyright = /** @type {((inputs: Landing_Footer_CopyrightInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_CopyrightInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_footer_copyright(inputs)
	if (locale === "en") return en_landing_footer_copyright(inputs)
	return es_landing_footer_copyright(inputs)
});